import { compare } from '../unknowns/compare';

export const getUniqueItems = <T>(
  arr: T[],
  equalityCondition: (referenceElement: T, comparisonElement: T) => boolean = compare
): T[] =>
  arr.filter(
    (referenceElement, index) =>
      arr.findIndex(comparisonElement => equalityCondition(referenceElement, comparisonElement)) === index
  );

export interface UniqueItemsCount<T> {
  Value: T;
  Count: number;
}

export const countUniqueItems = <T>(
  arr: T[],
  equalityCondition: (referenceElement: T, comparisonElement: T) => boolean = compare
): UniqueItemsCount<T>[] => {
  const uniqueCounts: UniqueItemsCount<T>[] = [];
  for (const referenceElement of arr) {
    const currentCount = uniqueCounts.find(count => equalityCondition(referenceElement, count.Value));
    if (!currentCount) uniqueCounts.push({ Value: referenceElement, Count: 1 });
    else currentCount.Count++;
  }

  return uniqueCounts;
};
